/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GenerateUploadUrlControllerGenerateUploadUrl201,
  GenerateUploadUrlDto,
  GetDownloadUrlControllerGetDownloadUrl200,
  GetFileByIdControllerGetFileById200,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Delete a file
 */
export const deleteFileControllerDeleteFile = (
  fileId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/files/${fileId}`,
    method: "DELETE",
    signal,
  });
};

export const getDeleteFileControllerDeleteFileMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFileControllerDeleteFile>>,
    TError,
    { fileId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFileControllerDeleteFile>>,
  TError,
  { fileId: string },
  TContext
> => {
  const mutationKey = ["deleteFileControllerDeleteFile"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFileControllerDeleteFile>>,
    { fileId: string }
  > = (props) => {
    const { fileId } = props ?? {};

    return deleteFileControllerDeleteFile(fileId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFileControllerDeleteFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFileControllerDeleteFile>>
>;

export type DeleteFileControllerDeleteFileMutationError = void;

/**
 * @summary Delete a file
 */
export const useDeleteFileControllerDeleteFile = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFileControllerDeleteFile>>,
      TError,
      { fileId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFileControllerDeleteFile>>,
  TError,
  { fileId: string },
  TContext
> => {
  return useMutation(
    getDeleteFileControllerDeleteFileMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get file by ID
 */
export const getFileByIdControllerGetFileById = (
  fileId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<GetFileByIdControllerGetFileById200>({
    url: `/v1/files/${fileId}`,
    method: "GET",
    signal,
  });
};

export const getGetFileByIdControllerGetFileByIdQueryKey = (fileId: string) => {
  return [`/v1/files/${fileId}`] as const;
};

export const getGetFileByIdControllerGetFileByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
  TError = void,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFileByIdControllerGetFileByIdQueryKey(fileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>
  > = ({ signal }) => getFileByIdControllerGetFileById(fileId, signal);

  return {
    queryKey,
    queryFn,
    enabled: fileId !== null && fileId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFileByIdControllerGetFileByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>
>;
export type GetFileByIdControllerGetFileByIdQueryError = void;

export function useGetFileByIdControllerGetFileById<
  TData = Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
  TError = void,
>(
  fileId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
          TError,
          Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFileByIdControllerGetFileById<
  TData = Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
  TError = void,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
          TError,
          Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFileByIdControllerGetFileById<
  TData = Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
  TError = void,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get file by ID
 */

export function useGetFileByIdControllerGetFileById<
  TData = Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
  TError = void,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileByIdControllerGetFileById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFileByIdControllerGetFileByIdQueryOptions(
    fileId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Generate signed upload URL for file
 */
export const generateUploadUrlControllerGenerateUploadUrl = (
  generateUploadUrlDto: GenerateUploadUrlDto,
  signal?: AbortSignal,
) => {
  return axiosClient<GenerateUploadUrlControllerGenerateUploadUrl201>({
    url: `/v1/files/generate-upload-url`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: generateUploadUrlDto,
    signal,
  });
};

export const getGenerateUploadUrlControllerGenerateUploadUrlMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateUploadUrlControllerGenerateUploadUrl>>,
    TError,
    { data: GenerateUploadUrlDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateUploadUrlControllerGenerateUploadUrl>>,
  TError,
  { data: GenerateUploadUrlDto },
  TContext
> => {
  const mutationKey = ["generateUploadUrlControllerGenerateUploadUrl"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateUploadUrlControllerGenerateUploadUrl>>,
    { data: GenerateUploadUrlDto }
  > = (props) => {
    const { data } = props ?? {};

    return generateUploadUrlControllerGenerateUploadUrl(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateUploadUrlControllerGenerateUploadUrlMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof generateUploadUrlControllerGenerateUploadUrl>>
  >;
export type GenerateUploadUrlControllerGenerateUploadUrlMutationBody =
  GenerateUploadUrlDto;
export type GenerateUploadUrlControllerGenerateUploadUrlMutationError = void;

/**
 * @summary Generate signed upload URL for file
 */
export const useGenerateUploadUrlControllerGenerateUploadUrl = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateUploadUrlControllerGenerateUploadUrl>>,
      TError,
      { data: GenerateUploadUrlDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateUploadUrlControllerGenerateUploadUrl>>,
  TError,
  { data: GenerateUploadUrlDto },
  TContext
> => {
  return useMutation(
    getGenerateUploadUrlControllerGenerateUploadUrlMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Mark file upload as complete (GCS notification webhook)
 */
export const markUploadCompleteControllerFileFinalizedTrigger = (
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/files/complete`,
    method: "POST",
    signal,
  });
};

export const getMarkUploadCompleteControllerFileFinalizedTriggerMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markUploadCompleteControllerFileFinalizedTrigger>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof markUploadCompleteControllerFileFinalizedTrigger>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["markUploadCompleteControllerFileFinalizedTrigger"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof markUploadCompleteControllerFileFinalizedTrigger>
      >,
      void
    > = () => {
      return markUploadCompleteControllerFileFinalizedTrigger();
    };

    return { mutationFn, ...mutationOptions };
  };

export type MarkUploadCompleteControllerFileFinalizedTriggerMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof markUploadCompleteControllerFileFinalizedTrigger>>
  >;

export type MarkUploadCompleteControllerFileFinalizedTriggerMutationError =
  unknown;

/**
 * @summary Mark file upload as complete (GCS notification webhook)
 */
export const useMarkUploadCompleteControllerFileFinalizedTrigger = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof markUploadCompleteControllerFileFinalizedTrigger>
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markUploadCompleteControllerFileFinalizedTrigger>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMarkUploadCompleteControllerFileFinalizedTriggerMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get signed download URL for file
 */
export const getDownloadUrlControllerGetDownloadUrl = (
  fileId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<GetDownloadUrlControllerGetDownloadUrl200>({
    url: `/v1/files/${fileId}/download-url`,
    method: "GET",
    signal,
  });
};

export const getGetDownloadUrlControllerGetDownloadUrlQueryKey = (
  fileId: string,
) => {
  return [`/v1/files/${fileId}/download-url`] as const;
};

export const getGetDownloadUrlControllerGetDownloadUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
  TError = void,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDownloadUrlControllerGetDownloadUrlQueryKey(fileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>
  > = ({ signal }) => getDownloadUrlControllerGetDownloadUrl(fileId, signal);

  return {
    queryKey,
    queryFn,
    enabled: fileId !== null && fileId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDownloadUrlControllerGetDownloadUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>
>;
export type GetDownloadUrlControllerGetDownloadUrlQueryError = void;

export function useGetDownloadUrlControllerGetDownloadUrl<
  TData = Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
  TError = void,
>(
  fileId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDownloadUrlControllerGetDownloadUrl<
  TData = Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
  TError = void,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDownloadUrlControllerGetDownloadUrl<
  TData = Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
  TError = void,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get signed download URL for file
 */

export function useGetDownloadUrlControllerGetDownloadUrl<
  TData = Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
  TError = void,
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDownloadUrlControllerGetDownloadUrl>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDownloadUrlControllerGetDownloadUrlQueryOptions(
    fileId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
